export default {
    comingSoon: "Coming soon",
    backHome: "Back to Home",
    pages: {
        about: "About",
        signUp: "Create account",
        forgotPassword: "Forgot Password",
        resetPassword: "Reset password",
        resetPasswordSent: "Reset link sent",
        confirmEmail: "Confirm email",
        userSetup: "Account Setup",
        myCart: "My Cart",
        accountSettings: "Account Settings",
        productsList: "Products",
        productDetails: "Product details",
        shippingDetails: "Shipping Details",
        shippingAddresses: "Shipping Addresses",
        shippingAddressNew: "New shipping address",
        shippingAddressEdit: "Edit Shipping Address",
        myOrders: "My Orders",
        orderDetails: "Order Details",
        orderConfirmation: "Order Confirmation",
        payment: "Payment",
        categories: "Categories",
        notifications: "Notifications",
        notFound: "Page not found"
    }
} as const;
